import { KeyboardArrowDown, KeyboardArrowUp, Search } from '@mui/icons-material';
import { SectionProps } from '../../types/IPlayerSearchFilter';
import LabelText from '../../ui/LabelText';
import { PlayerSearchFilterStyles } from '../../styled-components/PlayerComponent.styles';
import { IClubSectionState } from '../../types/IClubSearch';
import React, { useCallback, useEffect, useState } from 'react';
import RadioButton from '../../ui/CustomRadioButton';
import { ISelectedOption, useClubSearch } from '../../contexts/ClubSearchContext';
import FilteredDropdown from "../../ui/FilterDropdown/index";
import { useLoading } from '../../contexts/LoadingContext';
import BarChart from '../PlayerLanding/PlayerSearch/BarChart';
import { fetchAllAreaByRegions } from '../../services/dataService';
import { useNotification } from '../../contexts/NotificationContext';
import SecondaryButton from '../../ui/SecondaryButton';
import PrimaryButton from '../../ui/PrimaryButton';
import TotalAseetsLiabilities from '../ClubDetail/ClubFinancial/TotalAssetsLiabilities';
import { debounceFunction } from '../../utils/debounceFunction';
import Info_Icon from "../../assets/icons/info-icon.svg"
import { min } from 'lodash';
import { debug } from 'console';
import Switch from '../../ui/CustomSwitch';


const wagesSliderData = [
    { wages: 26, number: 5 },
    { wages: 27, number: 20 },
    { wages: 28, number: 10 },
    { wages: 29, number: 25 },
    { wages: 30, number: 30 },
    { wages: 31, number: 35 },
    { wages: 32, number: 50 },
    { wages: 33, number: 70 },
    { wages: 34, number: 40 },
    { wages: 35, number: 60 },
    { wages: 36, number: 30 },
    { wages: 37, number: 25 },
];

const Section: React.FC<SectionProps> = ({ label, isOpen, toggle, children }) => (
    <div className='section'>
        <div className='filters-sub-header' onClick={toggle}>
            <LabelText className='player-search-text'>{label}</LabelText>
            <div className='section-right'>
                {isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </div>
        </div>
        {isOpen && children}
    </div>
);

type EfficiencyOption = "any" | "earlyMover" | "average" | "lateMover";
type LeaguePosition = "anyLeague" | "top3" | "top6" | "topHalf" | "midTable" | "bottomHalf" | "relegationZone";

const transferWindowOptions: Record<EfficiencyOption, string> = {
    any: "Any",
    earlyMover: "Early Mover",
    average: "Average",
    lateMover: "Late Mover",
};

const leaguePositionOptions: Record<LeaguePosition, string> = {
    anyLeague: "Any",
    top3: "Top 3",
    top6: "Top 6",
    topHalf: "Top half",
    midTable: "Mid table",
    bottomHalf: "Bottom half",
    relegationZone: "Relegation zone"
}
interface ClubFilterSectionProps{
    fromClubCandidate? : boolean
}

const ClubFilterSection : React.FC<ClubFilterSectionProps> = ({fromClubCandidate}) => {
    const { regionAreaData, setRegionAreaData, setClubRegionValues, clubRegionValues,
        totalRevenue, totalCost, totalProfitLoss, totalDebt, totalIntangibleAssets, retainedEraning, totalReceivables, receivablesPercentage,avgSquadValue,avgSystemFit,avgPlayerAge,
        setClubCurrentPage, setTotalRevenue, setTotalCost, setTotalProfitLoss, setTotalIntangibleAssets, setTotalDebt, setTotalReceivables,
        setReceivablesPercentage, setIsClubFilterChange, setRetainedEraning, debtVsAssetsRatio, setDebtVsAssetsRatio , minMaxData ,setMinMaxData , setAvgSquadValue ,setAvgSystemFit,setAvgPlayerAge
    ,includeFinancial , setInculdeFinancial , wholeSquad , setWholeSquad} = useClubSearch();
    const { loading, startLoading, stopLoading } = useLoading();
    const { showNotification, hideNotification } = useNotification();
    const [isOpen, setIsOpen] = useState<IClubSectionState>({
        financial: true,
        squad: true,
        transferwindowefficiency: true,
        leagueposition: false,
        clubleague: false
    });
    const [selectedEfficiencyOption, setSelectedEfficiencyOption] = useState<EfficiencyOption>("any");
    const [selectedLeaguePosition, setSelectedLeaguePosition] = useState<LeaguePosition>("anyLeague");
    const [region, setRegion] = useState<ISelectedOption[]>(clubRegionValues);
    const [clubTotalRevenue, setClubTotalRevenue] = useState<{ min: number; max: number }>({ min: minMaxData?.minTotalRevenue!, max: minMaxData?.maxTotalRevenue! });
    const [clubTotalCost, setClubTotalCost] = useState<{ min: number; max: number }>({ min: minMaxData?.minTotalCost!, max: minMaxData?.maxTotalCost! });
    const [clubTotalProfitLoss, setClubTotalProfitLoss] = useState<{ min: number; max: number }>({ min: minMaxData?.minTotalProfitLoss!, max: minMaxData?.maxTotalProfitLoss! });
    const [clubTotalDebt, setClubTotalDebt] = useState<{ min: number; max: number }>({ min: minMaxData?.minTotalDebt!, max: minMaxData?.maxTotalDebt! });
    const [clubRetainEarnings, setClubRetainEarnings] = useState<{ min: number; max: number }>({ min: minMaxData?.minRetainedEarnings!, max: minMaxData?.maxRetainedEarnings! });
    const [clubDebtVsAssetsRatio, setClubDebtVsAssetsRatio] = useState<{ min: number; max: number }>({ min: minMaxData?.minDebtVsAssetsRatio!, max: minMaxData?.maxDebtVsAssetsRatio! });
    const [clubTotalIntangibleAssets, setClubTotalIntangibleAssets] = useState<{ min: number; max: number }>({ min: minMaxData?.minTotalIntangibleAssets!, max: minMaxData?.maxTotalIntangibleAssets! });
    const [clubTotalReceivables, setClubTotalReceivables] = useState<{ min: number; max: number }>({ min: minMaxData?.minTotalReceivables!, max: minMaxData?.maxTotalReceivables! });
    const [clubReceivablesPercentage, setClubReceivablesPercentage] = useState<{ min: number; max: number }>({ min: minMaxData?.minReceivablesPercentage!, max: minMaxData?.maxReceivablesPercentage! });
    const [additionalData, setAdditionalData] = useState<string[]>([]);
    const [clubSquadValue, setClubSquadValue] = useState<{ min: number; max: number }>({ min: minMaxData?.minAvSquadValue!, max: minMaxData?.maxAvSquadValue! });
    const [clubSquadPurchaseCost, setClubSquadPurchaseCost] = useState<{ min: number; max: number }>({ min: 0, max: 180000000 });
    const [clubSystemFit, setClubSystemFit] = useState<{ min: number; max: number }>({ min: minMaxData?.minAvSystemFit!, max: minMaxData?.maxAvSystemFit! });
    const [clubPlayerAge, setClubPlayerAge] = useState<{ min: number; max: number }>({ min: minMaxData?.minAvPlayerAge!, max: minMaxData?.maxAvPlayerAge! }); 
    const [clubWholeSquad, setClubWholeSquad] = useState<{ min: number; max: number }>({min: minMaxData?.minPurchaseVsMarketValue,max: minMaxData?.maxPurchaseVsMarketValue!});
    const [includeAffordability, setIncludeAffordability] = useState<boolean>(true);
    

    const toggleSection = useCallback((section: keyof IClubSectionState) => {
        setIsOpen(prevState => ({ ...prevState, [section]: !prevState[section] }));
    }, []);
    const handleSelectionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedEfficiencyOption(event.target.value as EfficiencyOption);
    };
    const handleLeaguePositionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedLeaguePosition(event.target.value as LeaguePosition);
    };
    const handleSelectionRegionChange = async (selectedOptions: ISelectedOption[], region: string) => {
        addAdditionalData('Regions');
        setRegion(prevRegion => {
            // Group the roles by region
            const rolesByRegion: Record<string, ISelectedOption[]> = {};
            prevRegion.forEach(area => {
                if (!rolesByRegion[area.region]) {
                    rolesByRegion[area.region] = [];
                }
                rolesByRegion[area.region].push(area);
            });
            // Remove existing options from the same region
            selectedOptions.forEach(newOption => {
                const existingOptions = rolesByRegion[newOption.region];
                if (existingOptions) {
                    existingOptions.forEach(existingOption => {
                        const index = prevRegion.findIndex(area => area.optionId === existingOption.optionId);
                        if (index !== -1) {
                            prevRegion.splice(index, 1);
                        }
                    });
                }
            });
            // Concatenate the unique options with the previous roles
            let updatedRegions = [...prevRegion];
            // If selectedOptions is empty, remove all options for the region
            if (selectedOptions.length === 0) {
                updatedRegions = updatedRegions.filter(area => area.region !== region);
            } else {
                updatedRegions = [...updatedRegions, ...selectedOptions];
            }
            return updatedRegions;
        });
    };
    const addAdditionalData = useCallback((message: string) => {
        if (!additionalData.includes(message)) {
            setAdditionalData(prev => [...prev, message]);
        }
    }, [additionalData]);
    const debouncedAddAdditionalData = debounceFunction(addAdditionalData, 500);

    const handleRevenueValueSliderChange = (min: number, max: number) => {
        setClubTotalRevenue(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Revenue changed');
    }
    const handleCostValueSliderChange = (min: number, max: number) => {
        setClubTotalCost(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Cost changed');
    }
    const handleProfitLossValueSliderChange = (min: number, max: number) => {
        setClubTotalProfitLoss(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Profit/Loss changed');
    }
    const handleDebtValueSliderChange = (min: number, max: number) => {
        setClubTotalDebt(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Debt changed');
    }
    const handleRetainEarnings = (min: number, max: number) => {
        setClubRetainEarnings(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Retained Earnings changed');
    }
    const handleDebtVSAssestRatioSliderChange = (min: number, max: number) => {
        setClubDebtVsAssetsRatio(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Debt VS asset ratio changed');
    }
    const handleIntangibleAssetsSliderChange = (min: number, max: number) => {
        setClubTotalIntangibleAssets(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Intangible assets changed');
    }
    const handleReceivablesSliderChange = (min: number, max: number) => {
        setClubTotalReceivables(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Outstanding receivables changed');
    }
    const handleEstimateReceivablesSliderChange = (min: number, max: number) => {
        setClubReceivablesPercentage(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Outstanding receivables changed');
    }

    const handleAVSquadValues = (min: number, max: number) => {
        setClubSquadValue(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Av. Player value');
    }

    const handleAVSysytemFit = (min: number, max: number) => {
        setClubSystemFit(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Av. System fit');
    }

    const handleAVPlayerAge = (min: number, max: number) => {
        setClubPlayerAge(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Av. player age');
    }

    const handleIncludeFinancial = () =>{
        setInculdeFinancial(!includeFinancial)
        addAdditionalData('include financial')
    }

    const handleClubWholeSquad = (min: number, max: number) => {
        setClubWholeSquad({ min: min, max: max });
        addAdditionalData('Purchase Cost / Current Value')
      }



    const generateMessage = () => {
        return (
            <div className='notification-message'>
                <Search />
                <div className='message-content'>
                    <LabelText className='notification-title'>Filters altered</LabelText>
                    <div className='notification-message'>
                        <LabelText className='notification-text'>Changes to: </LabelText>
                        <LabelText className='notification-alter-text'>{additionalData.join(', ')}</LabelText>
                    </div>
                </div>
            </div>
        );
    };

    const handleCancel = useCallback(() => {
        setClubTotalRevenue({ min: totalRevenue.min, max: totalRevenue.max });
        setClubTotalCost({ min: totalCost.min, max: totalCost.max })
        setClubTotalProfitLoss({ min: totalProfitLoss.min, max: totalProfitLoss.max })
        setClubTotalDebt({ min: totalDebt.min, max: totalDebt.max });
        setClubTotalIntangibleAssets({ min: totalIntangibleAssets.min, max: totalIntangibleAssets.max })
        setClubRetainEarnings({ min: retainedEraning.min, max: retainedEraning.max });//----
        setClubTotalReceivables({ min: totalReceivables.min, max: totalReceivables.max })
        setClubReceivablesPercentage({ min: receivablesPercentage.min, max: receivablesPercentage.max })
        setClubDebtVsAssetsRatio({ min: debtVsAssetsRatio.min, max: debtVsAssetsRatio.max })
        setClubSquadValue({ min: avgSquadValue.min, max: avgSquadValue.max });
        setClubSystemFit({ min: avgSystemFit.min, max: avgSystemFit.max });
        setClubPlayerAge({ min: avgPlayerAge.min, max: avgPlayerAge.max });
        setClubWholeSquad({min : wholeSquad.min , max : wholeSquad.max})
        setRegion(clubRegionValues);
        setInculdeFinancial(!includeFinancial)
        setAdditionalData([]);
        hideNotification();

    }, [
        totalRevenue, totalCost, totalProfitLoss, totalDebt, totalIntangibleAssets, totalReceivables, receivablesPercentage, hideNotification
        , setAdditionalData, debtVsAssetsRatio, clubRegionValues, hideNotification , avgSquadValue , avgSystemFit , avgPlayerAge , includeFinancial , wholeSquad , retainedEraning
    ]);

    const handleRunNewSearch = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        setClubCurrentPage(1)
        event.preventDefault();
        setTotalRevenue({ min: clubTotalRevenue.min, max: clubTotalRevenue.max });
        setTotalCost({ min: clubTotalCost.min, max: clubTotalCost.max })
        setTotalProfitLoss({ min: clubTotalProfitLoss.min, max: clubTotalProfitLoss.max })
        setTotalDebt({ min: clubTotalDebt.min, max: clubTotalDebt.max });
        setTotalIntangibleAssets({ min: clubTotalIntangibleAssets.min, max: clubTotalIntangibleAssets.max });
        setRetainedEraning({ min: clubRetainEarnings.min, max: clubRetainEarnings.max });//----
        setTotalReceivables({ min: clubTotalReceivables.min, max: clubTotalReceivables.max })
        setReceivablesPercentage({ min: clubReceivablesPercentage.min, max: clubReceivablesPercentage.max })
        setDebtVsAssetsRatio({ min: clubDebtVsAssetsRatio.min, max: clubDebtVsAssetsRatio.max });
        setAvgSquadValue({ min: clubSquadValue.min, max: clubSquadValue.max });
        setAvgSystemFit({ min: clubSystemFit.min, max: clubSystemFit.max });
        setAvgPlayerAge({ min: clubPlayerAge.min, max: clubPlayerAge.max });
        setWholeSquad({min : clubWholeSquad.min , max : clubWholeSquad.max})
        setClubRegionValues(region);
        setIsClubFilterChange(true);
        hideNotification();
        setAdditionalData([]);

    }, [
        clubTotalRevenue, clubTotalCost, clubTotalProfitLoss, clubTotalDebt, clubTotalIntangibleAssets, clubTotalReceivables,
        clubReceivablesPercentage, hideNotification, clubDebtVsAssetsRatio, region, setAdditionalData , , clubRetainEarnings, clubSquadValue , clubSystemFit , clubPlayerAge , clubWholeSquad
    ]);

    const commonAction = (
        <div className='notification-action'>
            <SecondaryButton label='Cancel' onClick={handleCancel} />
            <PrimaryButton iconType='refresh' label='Run new Search'
                onClick={handleRunNewSearch} />
        </div>
    );

    useEffect(() => {
        const fetchRegionAreaData = async () => {
            if (regionAreaData?.length === 0) {
                try {
                    const areaResponse = await fetchAllAreaByRegions();
                    if (areaResponse.isSuccess) {
                        setRegionAreaData(areaResponse.data);
                    } else {
                        console.error('Failed to fetch area data:', areaResponse);
                    }
                } catch (error) {
                    console.error('Error fetching region area data:', error);
                }
            }
        };

        fetchRegionAreaData();
    }, [regionAreaData]);

    useEffect(() => {
        if (additionalData.length > 0)
            showNotification('FilterNotification', generateMessage(), commonAction);
    }, [clubTotalRevenue, clubTotalCost, clubTotalProfitLoss, clubTotalDebt, clubTotalIntangibleAssets,
        clubTotalReceivables, clubReceivablesPercentage, clubDebtVsAssetsRatio,clubSquadValue,clubSystemFit,clubPlayerAge,includeFinancial,clubWholeSquad,clubRetainEarnings, additionalData ])

    useEffect(() => {
        setClubTotalRevenue({ min: totalRevenue.min, max: totalRevenue.max })
    }, [totalRevenue])
    useEffect(() => {
        setClubTotalCost({ min: totalCost.min, max: totalCost.max })
    }, [totalCost])
    useEffect(() => {
        setClubTotalProfitLoss({ min: totalProfitLoss.min, max: totalProfitLoss.max })
    }, [totalProfitLoss])
    useEffect(() => {
        setClubTotalDebt({ min: totalDebt.min, max: totalDebt.max })
    }, [totalDebt])
    useEffect(() => {
        setClubRetainEarnings({ min: retainedEraning.min, max: retainedEraning.max })
    }, [retainedEraning])
    useEffect(() => {
        setClubTotalIntangibleAssets({ min: totalIntangibleAssets.min, max: totalIntangibleAssets.max })
    }, [totalIntangibleAssets])
    useEffect(() => {
        setClubTotalReceivables({ min: totalReceivables.min, max: totalReceivables.max })
    }, [totalReceivables])
    useEffect(() => {
        setClubReceivablesPercentage({ min: receivablesPercentage.min, max: receivablesPercentage.max })
    }, [receivablesPercentage])
    useEffect(() => {
        setClubDebtVsAssetsRatio({ min: debtVsAssetsRatio.min, max: debtVsAssetsRatio.max })
    }, [debtVsAssetsRatio])
    useEffect(()=>{
        setClubSquadValue({ min: avgSquadValue.min, max: avgSquadValue.max })
    },[avgSquadValue])
    useEffect(()=>{
        setClubSystemFit({ min: avgSystemFit.min, max: avgSystemFit.max })
    },[avgSystemFit])
    useEffect(()=>{
        setClubPlayerAge({ min: avgPlayerAge.min, max: avgPlayerAge.max })
    },[avgPlayerAge])
    useEffect(()=>{
        setClubWholeSquad({ min: wholeSquad.min, max: wholeSquad.max })
    },[wholeSquad])
    // useEffect(() => {
    //     setRegion(clubRegionValues);
    // }, [clubRegionValues]);

    const handleSwitchClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        event.stopPropagation();
        setIncludeAffordability(!includeAffordability);
        addAdditionalData('Starts only')
      };

    return (
        <div className='player-search-filter-wrapper'>
            <PlayerSearchFilterStyles className='player-search-filter-sections'>
                {/* {includeFinancial && ( */}
                    {fromClubCandidate &&(
                        <div style={{display:'flex'}}>
                        <LabelText className='player-search-text'>Include Affordability</LabelText>
                            <Switch id="starts-only"
                                    toggled={includeAffordability} onChange={handleSwitchClick}
                                    source='Filter' isByComparison={false} />
                        </div>
                    )}
                    <Section label='Financial' isOpen={isOpen.financial!} toggle={() => toggleSection('financial')}>
                    <>
                        <div className="financial-search">
                                <div className="financial-search-label" style={{cursor:'pointer',backgroundColor : includeFinancial ? '#FFF' : '#00D1A8',border : includeFinancial ? '1px solid #DADADA' : '1px solid #00BE99'}} 
                                onClick={() =>{handleIncludeFinancial()}}>
                                    <LabelText className="secondary-cta-text">{includeFinancial ? 'Remove financial parameters' : 'Include financial parameters'}</LabelText>
                                </div>
                                <div className="financial-search-container">
                                    <div className="financial-search-content">
                                        <div style={{marginTop:'6px'}}><img src={Info_Icon}/></div>
                                        <div>
                                        <LabelText className="market-value-text">Only clubs who’ve supplied the relevant financial data will surface if financial parameters are included.</LabelText>
                                        <div></div>
                                        <LabelText className="global-search-text">Not all countries require their football clubs to release financial data, and some countries only require a limited set of data is made public.</LabelText>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        {includeFinancial && (
                            <>
                            <BarChart
                            header="Revenue"
                            data={wagesSliderData}
                            onDataUpdate={handleRevenueValueSliderChange}
                            initialMinValue={minMaxData?.minTotalRevenue!}
                            initialMaxValue={minMaxData?.maxTotalRevenue!}
                            isFor={"Transfer Value"}
                            defaultSelectedValue={[clubTotalRevenue.min, clubTotalRevenue.max]}
                        />
                        <BarChart
                            header="Costs"
                            data={wagesSliderData}
                            onDataUpdate={handleCostValueSliderChange}
                            initialMinValue={minMaxData?.minTotalCost!}
                            initialMaxValue={minMaxData?.maxTotalCost!}
                            isFor={"Transfer Value"}
                            defaultSelectedValue={[clubTotalCost.min, clubTotalCost.max]}
                        />
                        <BarChart
                            header="Profit/loss"
                            data={wagesSliderData}
                            onDataUpdate={handleProfitLossValueSliderChange}
                            initialMinValue={minMaxData?.minTotalProfitLoss!}
                            initialMaxValue={minMaxData?.maxTotalProfitLoss!}
                            isFor={"Transfer Value"}
                            defaultSelectedValue={[clubTotalProfitLoss.min, clubTotalProfitLoss.max]}
                        />
                        <BarChart
                            header="Debt"
                            data={wagesSliderData}
                            onDataUpdate={handleDebtValueSliderChange}
                            initialMinValue={minMaxData?.minTotalDebt!}
                            initialMaxValue={minMaxData?.maxTotalDebt!}
                            isFor={"Transfer Value"}
                            defaultSelectedValue={[clubTotalDebt.min, clubTotalDebt.max]}
                        />
                        <BarChart
                            // header="Assets/liabilities"
                            header='Retained Earnings'
                            data={wagesSliderData}
                            onDataUpdate={handleRetainEarnings}
                            initialMinValue={minMaxData?.minRetainedEarnings!}
                            initialMaxValue={minMaxData?.maxRetainedEarnings!}
                            defaultSelectedValue={[clubRetainEarnings.min, clubRetainEarnings.max]}
                            isFor={"Transfer Value"}
                            // isFor="Assets"
                        />
                        <BarChart
                            header="Debt VS asset ratio"
                            data={wagesSliderData}
                            onDataUpdate={handleDebtVSAssestRatioSliderChange}
                            initialMinValue={minMaxData?.minDebtVsAssetsRatio!}
                            initialMaxValue={minMaxData?.maxDebtVsAssetsRatio!}
                            defaultSelectedValue={[clubDebtVsAssetsRatio.min, clubDebtVsAssetsRatio.max]}
                        />
                        <BarChart
                            header="Intangible assets"
                            data={wagesSliderData}
                            onDataUpdate={handleIntangibleAssetsSliderChange}
                            initialMinValue={minMaxData?.minTotalIntangibleAssets!}
                            initialMaxValue={minMaxData?.maxTotalIntangibleAssets!}
                            isFor={"Transfer Value"}
                            defaultSelectedValue={[clubTotalIntangibleAssets.min, clubTotalIntangibleAssets.max]}
                        />
                        <BarChart
                            header="Outstanding receivables"
                            data={wagesSliderData}
                            onDataUpdate={handleReceivablesSliderChange}
                            initialMinValue={minMaxData?.minTotalReceivables!}
                            initialMaxValue={minMaxData?.maxTotalReceivables!}
                            isFor={"Transfer Value"}
                            defaultSelectedValue={[clubTotalReceivables.min, clubTotalReceivables.max]}
                        />
                        <BarChart
                            header="Players Receivables % of Total Revenue"
                            data={wagesSliderData}
                            onDataUpdate={handleEstimateReceivablesSliderChange}
                            initialMinValue={minMaxData?.minReceivablesPercentage!}
                            initialMaxValue={minMaxData?.maxReceivablesPercentage!}
                            defaultSelectedValue={[clubReceivablesPercentage.min, clubReceivablesPercentage.max]}
                        />
                            
                            </>
                        )}
                        
                    </>
                    </Section>
                {/* )} */}
               
                <Section label='Squad' isOpen={isOpen.squad!} toggle={() => toggleSection('squad')}>
                    <>
                        <BarChart
                            header="Av. Player value"
                            //togglelabel={valuelabel}
                            data={wagesSliderData}
                            onDataUpdate={handleAVSquadValues}
                            initialMinValue={minMaxData?.minAvSquadValue!}
                            initialMaxValue={minMaxData?.maxAvSquadValue!}
                            defaultSelectedValue={[clubSquadValue.min, clubSquadValue.max]}
                            isFor={"Transfer Value"}
                            //onChange={handleOnWagesToggleChange}
                        />
                        {/* <BarChart
                            header="squad purchase cost / current value"
                            togglelabel={squadPurchaseCost}
                            data={wagesSliderData}
                            onDataUpdate={handleWagesValueSliderChange}
                            initialMinValue={0}
                            initialMaxValue={180000000}
                            defaultSelectedValue={selectedLabel === "1" ? [WagesPW.min, WagesPW.max] : [WagesPA.min, WagesPA.max]}
                            isFor={"Transfer Value"}
                            onChange={handleOnWagesToggleChange}
                            selectedLabel={selectedLabel}
                        /> */}
                         <BarChart
                                    header="Purchase Cost / Current Value"
                                    data={wagesSliderData}
                                    onDataUpdate={handleClubWholeSquad}
                                    initialMinValue={minMaxData?.minPurchaseVsMarketValue!}
                                    initialMaxValue={minMaxData?.maxPurchaseVsMarketValue!}
                                    defaultSelectedValue={[clubWholeSquad.min, clubWholeSquad.max]}
                                  />
                        <BarChart
                            header="Av. System fit"
                            //togglelabel={valuelabel}
                            data={wagesSliderData}
                            onDataUpdate={handleAVSysytemFit}
                            initialMinValue={minMaxData?.minAvSystemFit!}
                            initialMaxValue={minMaxData?.maxAvSystemFit!}
                            defaultSelectedValue={[clubSystemFit.min, clubSystemFit.max]}
                           // isFor={"Transfer Value"}
                            //onChange={handleOnWagesToggleChange}
                        />

                        <BarChart
                            header="Av. player age"
                            //togglelabel={valuelabel}
                            data={wagesSliderData}
                            onDataUpdate={handleAVPlayerAge}
                            initialMinValue={minMaxData?.minAvPlayerAge!}
                            initialMaxValue={minMaxData?.maxAvPlayerAge!}
                            defaultSelectedValue={[clubPlayerAge.min, clubPlayerAge.max]}
                            //isFor={"Transfer Value"}
                            //onChange={handleOnWagesToggleChange}
                        /> 

                    </>
                </Section>
                {/* <Section label='Transfer window efficiency' isOpen={isOpen.transferwindowefficiency!} toggle={() => toggleSection('transferwindowefficiency')}>
                    {Object.entries(transferWindowOptions).map(([key, label]) => (
                        <div className="efficiency-options-wrapper">
                            <RadioButton
                                key={key}
                                label={label}
                                name={key}
                                value={key}
                                checked={selectedEfficiencyOption === key}
                                onChange={handleSelectionChange}
                            />
                        </div>
                    ))}
                </Section>
                <Section label='League position' isOpen={isOpen.leagueposition!} toggle={() => toggleSection('leagueposition')}>
                    {Object.entries(leaguePositionOptions).map(([key, label]) => (
                        <div className="efficiency-options-wrapper">
                            <RadioButton
                                key={key}
                                label={label}
                                name={key}
                                value={key}
                                checked={selectedLeaguePosition === key}
                                onChange={handleLeaguePositionChange}
                            />
                        </div>
                    ))}
                </Section> */}
                <Section label='Club league' isOpen={isOpen.clubleague!} toggle={() => toggleSection('clubleague')}>
                    {regionAreaData?.map((regionItem) => (
                        <FilteredDropdown
                            key={regionItem.region}
                            region={regionItem.region}
                            options={regionItem.areas}
                            type={regionItem.region}
                            onChange={handleSelectionRegionChange}
                            defaultSelectedOptions={region
                                .filter(item => item.region === regionItem.region)
                                .map(item => item.optionId)}
                            includeAll={true}
                            displayAsDropdown={true}
                        />
                    ))}
                </Section>

            </PlayerSearchFilterStyles>
        </div >
    )
}
export default ClubFilterSection;